import { gql, TypedDocumentNode } from "@apollo/client";
import { UniversitiesQuery } from "../types";

export const UNIVERSITY_QUERY: TypedDocumentNode<UniversitiesQuery> = gql`
  query getSpecificUniversity($legacyId: String!) {
    universities(legacyId: $legacyId) {
      id
      legacyId
      name
      logoUrl
      activeStudentCount
      alumniStudentCount
      address {
        id
        name
        address1
        address2
        city
        state
        zip
      }
      studentProgramSummary {
        programVersion
        activeLevel0
        activeLevel1
        activeLevel2
        activeLevel3
        completions
      }
    }
  }
`;
